import React, { FC } from 'react'
import 'slick-carousel/slick/slick.css'

import Svg from 'components/svg'
import { SliderButton } from './styled'

type ButtonProps = {
  isForward?: boolean
  onClick?: () => void
}

export const ArrowButton: FC<ButtonProps> = ({ isForward, onClick }) => (
  <SliderButton
    isForward={isForward}
    onClick={onClick}
    aria-label={`${isForward ? 'Next' : 'Previous'} slide`}
  >
    <Svg viewbox="0 0 22.138 16.646">
      <path
        stroke="currentColor"
        strokeWidth="3"
        fill="none"
        d="M12.631 15.577L20 8.323l-7.369-7.254M19.137 8.058l-18.99.041"
      />
    </Svg>
  </SliderButton>
)

const sliderNavSettings = {
  nextArrow: <ArrowButton isForward />,
  prevArrow: <ArrowButton />,
}

export default sliderNavSettings
